<template>
  <Transition name="fade">
    <div v-if="show" class="translation-overlay">
      <div class="translation-content">
        <div class="spinner"></div>
        <p class="loading-message">
          {{ loadingMessage }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  interface Props {
    show: boolean
    locale?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    locale: 'pt-BR',
  })

  /**
   * Mensagem de loading customizada por idioma
   */
  const loadingMessage = computed(() => {
    const locale = props.locale.toLowerCase()

    if (locale.startsWith('es')) {
      return 'Preparando contenido...'
    }

    if (locale.startsWith('en')) {
      return 'Preparing content...'
    }

    return 'Preparando conteúdo...'
  })
</script>

<style scoped>
  .translation-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  }

  .translation-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #0080a3;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loading-message {
    font-size: 1.125rem;
    font-weight: 500;
    color: #333333;
    margin: 0;
    text-align: center;
  }

  /* Transição suave */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  /* Responsividade */
  @media (max-width: 768px) {
    .spinner {
      width: 40px;
      height: 40px;
      border-width: 3px;
    }

    .loading-message {
      font-size: 1rem;
      padding: 0 1rem;
    }
  }
</style>
